import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
import { ApiService } from './api.service';
import { SharedService } from './shared.service';
import { localStorageService } from './localstorage.service';
import { SocketsService } from './socket/socket.service';

@Injectable({
  providedIn: 'root',
})
export class ChatSupportService {
  public restartChatEvent: EventEmitter<any> = new EventEmitter<any>();
  public getUpdatedTicketData: EventEmitter<any> = new EventEmitter<any>();
  public readMessage = new EventEmitter<any>();
  public ticketStatusChangedEvent: EventEmitter<any> = new EventEmitter();
  public supportMessageSub: EventEmitter<any> = new EventEmitter();
  public adminChatRefresh: EventEmitter<any> = new EventEmitter();
  public newTicketCreation: EventEmitter<any> = new EventEmitter();
  public userActionMsg: EventEmitter<any> = new EventEmitter();
  public userLiveStatus: EventEmitter<any> = new EventEmitter();
  getUserWebLocation: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  getUserUpdatedStatus: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  getUserUpdatedStatusV2: BehaviorSubject<any> = new BehaviorSubject<any>(
    false
  );
  public message_open$: BehaviorSubject<any> = new BehaviorSubject('');
  newTickets: any = [];
  chatSuggestions: any = [];
  clientConnected: Subject<any> = new Subject();
  clientDisconnected: Subject<any> = new Subject();
  clientMessage: Subject<any> = new Subject();
  userDetails: any;
  custDraftMessage: Subject<any> = new Subject();
  refreshChatOnSocketBreak: Subject<any> = new Subject();
  onceSub: any = true;
  alreadyConnectedArr: any = [];
  public adminChatHistory: EventEmitter<any> = new EventEmitter();
  public adminGroupChatData: EventEmitter<any> = new EventEmitter();
  selected_chat = new EventEmitter<any>();
  getRecentChat = new EventEmitter<any>();
  recentchatData: any;
  adminData: any;
  agent_list: any = [];
  changeOrder = new EventEmitter<any>();
  public supportChatData: EventEmitter<any> = new EventEmitter();
  public visitorChatData: EventEmitter<any> = new EventEmitter();
  public openGlobalChat: EventEmitter<any> = new EventEmitter();
  public userChatData: EventEmitter<any> = new EventEmitter();
  is_dummy: any;
  support_type_name: any;
  supportTyping: any = false;
  toastRef: any;

  constructor(
    private _socket: SocketsService,
    private _router: Router,
    public _shared: SharedService,
    // private toastr: ToastrService,
    public router: Router,
    private _api: ApiService,
    private _local: localStorageService,
  ) {
    this._socket.socketConnected.subscribe((data: any) => {
      console.log("Iinninin");
      
      this.is_dummy = this._local.customGetItem('is_dummy')
        ? parseInt(this._local.customGetItem('is_dummy') || '1')
        : '0';
      this.userDetails = this._local.customGetItem('admin_profile') || null;

      if (data == 1 && this.onceSub) {
        this.onceSub = false;
        this._socket.emit('LoggedInUsers', {
          admin_id: this.userDetails.admin_id,
          room: `Admin Room: ${this.userDetails.admin_id}`,
        });

        this._socket.on('disconnect', () => {
          console.log('_socket disconnect ------');
          const body = {
            admin_id: this.userDetails['user_id'],
          };
          this._socket.emit('support_disconnected', body);
        });

        this._socket.on('connect_support', (data: any) => {
          this.supportConnected(
            this.userDetails['admin_name'],
            this.userDetails['admin_id'],
            'admin_assigned',
            data.ticketId
          );
        });

        this._socket.on('user', () => {
          this.login();
        });

        setInterval(() => {
          this.login();
        }, 60 * 1000);

        this._socket.on('on_user_online', (user_data: any) => {
          this.clientConnected.next(user_data.customer_email);
        });

        this._socket.on('customer_disconnected', (data: any) => {
          this.clientDisconnected.next(data);
        });

        this._socket.on('on_user_offline', (user_data: any) => {
          this.clientDisconnected.next(user_data.customer_email);
        });

        this._socket.on('cust_msg_read', (data: any) => {
          this.readMessage.emit(data);
        });

        this._socket.on('customer_message', (data: any) => {
          if (data) {
            const ticket_id = this._router.url
              .split('/')
              .slice(-1)[0]
              .split('?')[0];
            if (!(ticket_id && ticket_id == data.ticketId)) {
              // this.notifications.next({ ...data, type: 'incoming' }); // send notification to admin
            }
            const user_message = data;
            if (user_message.sourceType && user_message.sourceType === 'chat') {
              user_message.message = this._shared.getURLFromString(
                user_message.message
              );
            }
            if (user_message.fromName) {
              user_message.user_full_name = user_message.fromName;
              user_message.user_name = user_message.fromName
                .split(' ')
                .reduce(
                  (a: any, b: any) =>
                    a.charAt(0).toUpperCase() + b.charAt(0).toUpperCase(),
                  ''
                );
            }
            this.clientMessage.next({ ...data, type: 'incoming' });
          }
        });

        this._socket.on('user_action_msg', (data: any) => {
          if (data) {
            this.userActionMsg.next(data);
          }
        });

        let typingDuration: any;
        this._socket.on('cust_msg_typing', (data: any) => {
          if (data) {
            if (data.msg_typing == true) {
              clearTimeout(typingDuration);
              data['typingAnimation'] = true;
              this.custDraftMessage.next(data);
              typingDuration = setTimeout(() => {
                data['typingAnimation'] = false;
                this.custDraftMessage.next(data);
              }, 1000);
            } else {
              data['typingAnimation'] = false;
              this.custDraftMessage.next(data);
            }
          }
        });

        this._socket.on('prev_chat_loaded', (data: any) => {
          if (data && data.prev_chat_loaded) {
            // let adminData: any = localStorage.getItem('profileData') || null;
            // adminData = JSON.parse(adminData)[0];
            this.supportConnected(
              this.adminData['admin_name'],
              this.adminData['admin_id'],
              'admin_assigned',
              null,
              true
            );
          }
        });

        this._socket.on('on_new_ticket', (data: any) => {
          this.newTicketCreation.next(data);
        });

        this._socket.on('admin_chat_history', (data: any) => {
          this.adminChatHistory.next(data);
        });

        this._socket.on('admin_group_chat_data', (data: any) => {
          this.adminGroupChatData.next(data);
        });

        this._socket.on('user_web_location_updated', (data: any) => {
          this.getUserWebLocation.next(data);
        });

        this._socket.on('user_status_updated', (data: any) => {
          this.getUserUpdatedStatus.next(data);
        });

        this._socket.on('support_message', (data: any) => {
          this.supportMessageSub.next(data);
        });

        this._socket.on('admin_chat_refresh', (data: any) => {
          this.adminChatRefresh.next(data);
        });

        this._socket.on('support_chat_data', (data: any) => {
          this.supportChatData.next(data);
        });

        this._socket.on('ticket_status_changed', (data: any) => {
          this.ticketStatusChangedEvent.next(data);
        });
        this._socket.on('visitor_chat_data', (data: any) => {
          this.visitorChatData.next(data);
        });

        this._socket.on('user_chat_data', (data: any) => {
          this.userChatData.next(data);
        });

        this._socket.on('support_msg_typing', (data: any) => {
          let profileData: any = this._local.customGetItem('admin_profile');          
          this.adminData = profileData;
          if (data?.admin_id != this.adminData.admin_id) {
            this.support_type_name = data.admin_typing;
            this.supportTyping = true;
            setTimeout(() => {
              this.supportTyping = false;
            }, 1500);
          }
        });

        this._socket.on('restart_chat', (response: any) => {
          this.restartChatEvent.next(response);
        });

        this._socket.on('get_updated_ticket_data', (response: any) => {
          this.getUpdatedTicketData.next(response);
        });

        this._socket.on('receive_notification', (data: any) => {
          console.log(data, 'notificationnotificationnotificationnotification');
          let parseData = JSON.parse(data);
          this._shared.customPopups(
            parseData.message.message,
            0,
          );

          // this.redirection_action(parseData.message);
          console.log('inmnnininini-=--=');

          this.message_open$.next(parseData);
        });
      } else {
        this._socket.on('connect', () => {
          setTimeout(() => {
            this.refreshChatOnSocketBreak.next(
              this._router.url.split('/').slice(-1)[0].split('?')[0]
            );
          }, 3000);
          return console.log('trying to connect again!!!');
        });
      }
    });
  }

  login() {
    let user: any = localStorage.getItem('profileData') || null;
    if (user) {
      user = JSON.parse(user);
      // if (user[0]['role_id'] == 1) {
      this._socket.emit('user', user[0]);
      // }
    } else {
      // this.logout();
    }
  }

  // logout() {
  //   this._socket.emit('logout');
  // }

  supportConnected(
    adminName: any,
    adminId: any,
    connectionType: any,
    ticket_id: any = null,
    prevChatLoaded?: any
  ) {
    if (!ticket_id) {
      ticket_id = this._router.url.split('/').slice(-1)[0].split('?')[0];
      return;
    }
    const supportInfoObj: any = {
      // supportSocketId: this._socket.ioSocket.id,
      ticketId: ticket_id,
      admin_name: adminName,
      admin_id: adminId,
      connectionType: connectionType,
      status:
        this.userDetails && this.userDetails['awayMode'] ? 'Away' : 'Online',
    };
    if (prevChatLoaded) {
      supportInfoObj['prevChatLoaded'] = true;
    }
    supportInfoObj['message_id'] = this.GenerateID();
    this._socket.emit('support_connected', supportInfoObj);
    if (connectionType == 'admin_assigned') {
      this.alreadyConnectedArr.push(Number(ticket_id));
    }
  }

  checkCustomerStatus(ticket_id: any) {
    this._api
      .api(
        { ticket_id: ticket_id },
        `chatbot/ask_ticket_customer_status`,
        'post'
      )
      .subscribe((res: any) => {
        if (res.is_error == 0) {
          return true;
        } else {
          this._shared.customPopups(res.msg, 1);
        }
        return false;
      });
  }

  getUserTickets(ticket_id: any) {
    if (!this.userDetails) {
      return;
    }
    this.supportConnected(
      this.userDetails['admin_name'],
      this.userDetails['admin_id'],
      'admin_connected_back',
      ticket_id
    );
  }

  sendSupportMessage(chat_data: any) {
    this._api
      .api(chat_data, `chatbot/send_admin_message`, 'post')
      .subscribe((res: any) => {
        if (res.is_error == 0) {
          if (
            res.data &&
            ((res.data.hasOwnProperty('message_type') &&
              res.data['message_type'] === 'admin_reassigned') ||
              (res.data.hasOwnProperty('messageType') &&
                res.data['messageType'] === 'admin_reassigned'))
          ) {
            return res.data;
          }
        } else {
          this._shared.customPopups(res.msg, 1);
        }
      });
  }

  GenerateID() {
    let randomId = '';
    const charSet =
      'ABCDEFGHIkLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 40; i++) {
      randomId += charSet.charAt(Math.floor(Math.random() * charSet.length));
    }
    return randomId;
  }

  supportMessage(data: any) {
    data['message_id'] = this.GenerateID();
    data['admin_id'] = this.userDetails.admin_id;
    data['admin_name'] = data.agent_name;
    if (!data.ticketId) {
      return;
    }
    this._socket.emit('support_message', data);
  }

  msgTyping(ticketId: any, adminData?: any) {
    let params = {
      msg_typing: true,
      ticketId: ticketId,
      admin_typing: `${adminData.admin_name} is typing...`,
      admin_id: adminData.admin_id,
    };
    this._socket.emit('support_msg_typing', params);
  }

  msgRead(ticketId?: any) {
    let params = {
      messages_read: true,
      ticketId: ticketId,
    };
    this._socket.emit('support_msg_read', params);
  }

  getChatSuggestions() {
    this._api
      .api({}, `chatbot/chat_suggestions`, 'get')
      .subscribe((res: any) => {
        if (res.is_error == 0) {
          this.chatSuggestions = res.data;
        } else {
          this._shared.customPopups(res.msg, 1);
        }
      });
  }

  ticketStatusChanged(ticketStatus: any, data: any) {
    let params = {
      ticketId: data.ticketId,
      message: data.message,
      isAdminMessage: '1',
      ticketStatus: ticketStatus,
      messageType: 'ticket_closed',
    };
    this._socket.emit('ticket_status_changed', params);
  }

  joinUserSocket(user_id: any) {
    this._socket.emit('support_user_status', { user_id: user_id });
    this._socket.on('user_status', (data: any) => {
      if (data) {
        this.userLiveStatus.emit(data);
      }
    });
  }

  openChat(user_id: any) {
    this._socket.emit('support_open_chat', {
      user_id: user_id,
      message: 'I’m here if you need help 👋',
    });
  }

  leaveAdmin(ticket_id: any, admin_id: any) {
    this._socket.emit('admin_leave', {
      ticketId: ticket_id,
      admin_id: admin_id,
    });
  }

  getAdminGroupChatData(ticket_id: any) {
    console.log(ticket_id, 'ticket_id');

    this._socket.emit('get_admin_group_chat_data', { ticketId: ticket_id });
  }

  restartChat(ticket_id: any) {
    this._socket.emit('restart_chat', { ticketId: ticket_id });
  }

  updateTicketData(data: any) {
    this._socket.emit('update_ticket_data', {
      ticketId: data.ticketId,
      admin_id: data.admin_id,
      admin_name: data.admin_name,
    });
  }

  ngOnDestroy() {}

  getSupportChatData() {
    this.is_dummy = localStorage.getItem('is_dummy')
      ? parseInt(localStorage.getItem('is_dummy') || '1')
      : '0';
    this._socket.emit('get_support_chat_data', {
      admin_id: this.userDetails.admin_id,
      is_dummy: this.is_dummy,
    });
  }

  get_visitor_chat_data(data: any) {
    console.log(data, 'dat6at====');
    this._socket.emit('get_visitor_chat_data', data);
  }

  getUserData(data: any) {
    this.is_dummy = localStorage.getItem('is_dummy')
      ? parseInt(localStorage.getItem('is_dummy') || '1')
      : '0';
    this._socket.emit('get_user_chat_data', {
      ...data,
      is_dummy: this.is_dummy,
      admin_id: this.userDetails.admin_id,
    });
  }

  redirection_action(notification: any) {
    let url = '';
    let metadata = notification;
    console.log(metadata, 'metadata');
    if (metadata.redirection_type == 10) {
      let data = JSON.parse(JSON.parse(metadata.metadata));
      url = `/app/chatsupport?user_id=${data.user_id}`;
    }

    this.router.navigateByUrl(url);
  }
}
